import React, { Component } from 'react';

import { database  } from '../config/base';
import firebase from 'firebase';
import FileUploader from 'react-firebase-file-uploader';
class PostModal extends Component {
  constructor() {
    super();
    this.state = {
      post:{
        id:'',
        title:'',
        content:'',
        category:'',
        avatar: '',
        isUploading: false,
        progress: 0,
        avatarURL: ''
      },
      inputsNotValide:true
    };

    this.handleTitle = this.handleTitle.bind(this)
    this.handleContent = this.handleContent.bind(this)
    this.handleCategory = this.handleCategory.bind(this)
  }

  handleTitle(event)
  { if(event.target.value!=null )
    {
      this.setState({
        post:{
          id:Date.now(),
          title:event.target.value,
          content:this.state.post.content,
          category:this.state.post.category,
        },
        inputsNotValide:false
      })
    }
    else {
      this.setState({
        inputsNotValide:true
      })
    }
    if (this.state.post.content==='')
    {
      this.setState({
        inputsNotValide:true
      })
    }
  }

  handleContent(event)
  {
    if(event.target.value!=null)
    {
      this.setState({
        post:{
          id:Date.now(),
          title:this.state.post.title,
          content:event.target.value,
          category:this.state.post.category

        },
        inputsNotValide:false
      })
    }
    else {
      this.setState({
        inputsNotValide:true
      })
    }
    if (this.state.post.title==='')
    {
      this.setState({
        inputsNotValide:true
      })
    }
  }

  handleCategory(event)
  {
    if(event.target.value!=null)
    {
      this.setState({
        post:{
          id:Date.now(),
          title:this.state.post.title,
          content:this.state.post.content,
          category:event.target.value,

        },
        inputsNotValide:false
      })
    }
    else {
      this.setState({
        inputsNotValide:true
      })
    }
    if (this.state.post.title==='')
    {
      this.setState({
        inputsNotValide:true
      })
    }
  }
  addPost(event)
  {
    var url='/posts/'

    database.ref(url).push(this.state.post).key ;

    this.setState({
      post:{
        id:Date.now(),
        title:'',
        content:'',
        progress:'0'
      },
      inputsNotValide:true
    })

  }

  handleUploadStart = () => this.setState({isUploading: true, progress: 0});

  handleProgress  (progress)
  {
    this.setState({progress})
    console.log(progress)
  }

  handleUploadError  (error)  {
  this.setState({isUploading: false});
  console.error(error);
  }

  handleUploadSuccess = (filename) =>
  {
    this.setState({avatar: filename, progress: 100, isUploading: false});
    firebase.storage().ref('images').child(filename).getDownloadURL().then(url => this.setState({avatarURL: url}));
  };

  render() {

    return (
      <div className="modal fade" id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog" role="document">
          <form>
            <div className="modal-content">

              <label>Avatar:</label>
              {this.state.isUploading &&
                <div className="progress">
                  <div className="progress-bar"   style={{width: this.state.progress+'%'}} role="progressbar" aria-valuenow={this.state.progress} aria-valuemin="50" aria-valuemax="100"></div>
                </div>
              }
              { this.state.avatarURL &&
                <img src={this.state.avatarURL} />
              }
              <FileUploader
                accept="image/*"
                name="avatar"
                randomizeFilename
                storageRef={firebase.storage().ref('images')}
                onUploadStart={this.handleUploadStart.bind(this)}
                onUploadError={this.handleUploadError.bind(this)}
                onUploadSuccess={this.handleUploadSuccess.bind(this)}
                  onProgress={this.handleProgress.bind(this)}
                />
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">Add Post</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-default">Title</span>
                  </div>
                  <input type="text" onChange={this.handleTitle} value={this.state.post.title} required className="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default"/>
                </div>
              </div>
              <div className="modal-body">
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-default">Category</span>
                  </div>
                  <input type="text" onChange={this.handleCategory} value={this.state.post.category} required className="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default"/>
                </div>
              </div>
              <div className="modal-body">
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-default">Content</span>
                  </div>
                  <input type="text" onChange={this.handleContent} value={this.state.post.content} required className="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default"/>
                </div>
              </div>
              <div className="modal-footer">
                <button type="submit" className="btn btn-danger" data-dismiss="modal"><i className="fa fa-close" aria-hidden="true"></i></button>
                <button type="button" data-dismiss="modal" aria-label="Close"  onClick={this.addPost.bind(this)} disabled={this.state.inputsNotValide} className="btn btn-primary"><i className="fa fa-plus" aria-hidden="true"></i></button>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default PostModal;



// WEBPACK FOOTER //
// ./src/components/PostModal.js